












import { Component, Vue, Watch, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterState } from '../../stores/modules/filter';
import { EventBus } from '../../event-bus';

const filter = namespace('filter');

@Component({
  components: {}
})
export default class ArchivedFilter extends Vue {
  private selected: boolean = false;

  @filter.State(x => x.filter.archive) archiveSet?: boolean;
  @filter.Mutation('setFilterItem') setFilterItem!: (item: {
    key: keyof FilterState['filter'];
    val: any;
  }) => void;
  mounted() {
    this.selected = !!this.archiveSet;
  }
  @Watch('selected')
  onSelect(selected: boolean) {
    EventBus.$emit('library-in-archive', this.selected);
    this.setFilterItem({ key: 'archive', val: selected });
  }
}
